import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const logos = [
  {
    name: 'Klant 1',
    src: 'https://storage.readdy-site.link/project_files/858ea215-68cb-4d8e-b2ba-23583e2fd22e/b9c3259d-be2f-4cbe-8340-3b49e714686f_4.png?v=1f3d8dee4944f1ac09d7c045cb5f2d82',
  },
  {
    name: 'Klant 2',
    src: 'https://storage.readdy-site.link/project_files/858ea215-68cb-4d8e-b2ba-23583e2fd22e/d0728a4f-2807-4a08-b44e-681db14dd8a4_2.png?v=3ab37f3bf1f3800180dea30412b2df00',
  },
  {
    name: 'Klant 3',
    src: 'https://storage.readdy-site.link/project_files/858ea215-68cb-4d8e-b2ba-23583e2fd22e/1caf803e-ef19-4dd2-aee5-cd85e3948541_3.png?v=8f3688ae08bc6a916ebef2307f7bbee9',
  },
  {
    name: 'Klant 4',
    src: 'https://storage.readdy-site.link/project_files/858ea215-68cb-4d8e-b2ba-23583e2fd22e/51f94262-1796-4bb4-a263-a7bedf053353_5.png?v=f5297d8d2c7b7e2debf36c30982d4751',
  },
  {
    name: 'Klant 5',
    src: 'https://storage.readdy-site.link/project_files/858ea215-68cb-4d8e-b2ba-23583e2fd22e/4cf414d6-0117-4ea6-affe-ec1a159791e4_6.png?v=df53c5678fdc74dc42a3f98fa59cd37c',
  },
  {
    name: 'Klant 6',
    src: 'https://storage.readdy-site.link/project_files/858ea215-68cb-4d8e-b2ba-23583e2fd22e/6be65c2e-258e-49a3-9e3a-e1cfff62df97_7.png?v=1d045bd3cf8e861c88400ad7f1f69d0a',
  },
];

export default function ClientLogos() {
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, { once: true, margin: '-60px' });

  return (
    <section ref={ref} className="py-14 bg-white border-t border-b border-[#0A1628]/6 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mb-10">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.4 }}
          className="text-center"
        >
          <p className="text-[#0A1628]/40 text-xs uppercase tracking-widest font-semibold mb-2">
            Zij gingen u voor
          </p>
          <h2 className="font-heading font-bold text-[#0A1628] text-xl md:text-2xl">
            Ondernemers die al <span className="text-[#3B9EE8]">slimmer inkopen via DUC</span>
          </h2>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={inView ? { opacity: 1 } : {}}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="relative overflow-hidden"
      >
        {/* fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />

        <div className="flex gap-10 items-center" style={{ animation: 'duc-marquee 24s linear infinite', width: 'max-content' }}>
          {[...logos, ...logos, ...logos].map((logo, i) => (
            <div
              key={`${logo.name}-${i}`}
              className="flex-shrink-0 w-[432px] h-60 flex items-center justify-center"
            >
              <img
                src={logo.src}
                alt={logo.name}
                className="max-h-48 max-w-full w-auto object-contain transition-all duration-300"
              />
            </div>
          ))}
        </div>
      </motion.div>

      <style>{`
        @keyframes duc-marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(calc(-100% / 3)); }
        }
      `}</style>
    </section>
  );
}
